<div class="ag-name-value">
    <span (click)="viewGridSettings()" [secure]="gridSettingsSecurity"><i class="fas fa-cog"></i></span>
</div>